import {
  MASTER_CLEAN_REQUEST,
  MASTER_FETCH_REQUEST,
  MASTER_FETCH_REQUEST_FAILURE,
  MASTER_FETCH_REQUEST_SUCCESS,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const mastersReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case MASTER_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case MASTER_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case MASTER_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
        payload: [],
      });

    case MASTER_CLEAN_REQUEST:
      return Object.assign({}, state, {
        loading: false,
        payload: [],
        errors: {},
      });

    default:
      return state;
  }
};

export default mastersReducer;
